import { CognitoPersistKeys } from "@liveart/injectables/dist/user/getValueFromStorage";

export function persistUserAccessToken(accessToken: string) {
    globalThis?.localStorage?.setItem(
        CognitoPersistKeys.ACCESS_TOKEN,
        accessToken,
    );
}
